// eslint-disable-next-line angular/factory-name
angular.
module("UIStateManager").
factory("UIStateManager", function uiStateManagerFactory() {
	"use strict";

	function UIStateManager(state, initData) {
		this.UIState = state;
		this.data = initData || {};
		this.eventBindings = [];
	}

	UIStateManager.prototype.is = is;
	UIStateManager.prototype.isnt = isnt;
	UIStateManager.prototype.set = set;
	UIStateManager.prototype.get = get;
	UIStateManager.prototype.on = on;
	UIStateManager.prototype.off = off;

	function is(s) {
		return this.UIState === s;
	}

	function isnt(s) {
		return this.UIState !== s;
	}

	function set(s, data) {
		// eslint-disable-next-line no-param-reassign
		data = data || {};

		this.UIState = s;
		this.data = data;

		for (var i = 0; i < this.eventBindings.length; i++) {
			var b = this.eventBindings[i];
			if (b.state === s && typeof b.fn === "function") {
				b.fn(data);
			}
		}
	}

	function get(prop) {
		return this.data[prop];
	}

	function on(s, fn) {
		this.eventBindings.push({
			state: s,
			fn: fn,
		});
	}

	function off(s) {
		for (var i = 0; i < this.eventBindings.length; i++) {
			if (this.eventBindings[i].state === s) {
				this.eventBindings.splice(i, 1);
			}
		}
	}

	return UIStateManager;
});
